// dev-portal/src/pages/auth/ForgotPassword.jsx

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import Footer from '../../components/shared/Footer';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const res = await api.post('/api/forgot-password', { email });
      setMessage(res.data.message || 'If this email exists, a reset link was sent.');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to request reset link.');
    }
  };

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
        <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 w-full max-w-md space-y-4">
          <div className="flex justify-between items-center mb-4">
            <Link to="/" className="text-sm text-blue-600 hover:underline">
              ← Back to Marketplace
            </Link>
            <Link to="/login" className="text-sm text-blue-600 hover:underline">
              Back to Login →
            </Link>
          </div>

          <h2 className="text-xl font-bold text-center">Forgot Password</h2>
          
          {message && <p className="text-green-600 text-sm text-center">{message}</p>}
          {error && <p className="text-red-600 text-sm text-center">{error}</p>}

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              type="email"
              value={email}
              placeholder="Enter your email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition-colors"
            >
              Send Reset Link
            </button>
          </form>

          <div className="text-center text-sm text-gray-500 mt-4">
            Remember your password?{' '}
            <Link to="/login" className="text-blue-600 hover:underline">
              Login
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}